import { GetterTree } from 'vuex';
import { getPageTimes, getVideoTime } from '@/document-tracking/helpers/tracking.helper';
import { IPageTime } from '@/document-view/types/page-time';
import { RootState } from '@/store/store';
import { IDocumentViewState } from '@/store/stores/document-view.store';
import { IPageTracking } from '@/document-tracking/types/page-tracking';
import { IVisitTracking } from '@/document-tracking/types/visit-tracking';

export const getterTracking: string = 'tracking';
export const getterTrackingStats: string = 'trackingStats';

export const getters: GetterTree<IDocumentViewState, RootState> = {
  [getterTracking](
    state: IDocumentViewState,
    _,
    rootState: RootState
  ): {
    videoTracking?: { videoUrl: string; thumbUrl: string; viewDuration: number };
    pageTimes: IPageTime[];
  } {
    const { document } = rootState['dealroomView'];
    if (!state.tracking || !document?.pages?.length) {
      return null;
    }
    const { clickTrackings = [], videoTrackings, pageTrackings } = state.tracking;
    const pageTimes: IPageTime[] = getPageTimes(
      clickTrackings,
      videoTrackings,
      pageTrackings,
      state.selectedRecipientId,
      document.pages
    );
    if (!document.video?.video) {
      return { videoTracking: undefined, pageTimes };
    }
    const { id: engagementVideoId, videoUrl, thumbUrl } = document.video.video;
    return {
      videoTracking: {
        videoUrl,
        thumbUrl,
        viewDuration: getVideoTime(engagementVideoId, videoTrackings, state.selectedRecipientId),
      },
      pageTimes,
    };
  },
  [getterTrackingStats](
    state: IDocumentViewState
  ): { documentVisitCount: number; documentVisitTime: number; uniqueViewerCount: number } {
    const documentVisitCount: number = state.tracking?.visitTrackings?.length || 0;

    const documentVisitTime: number = state.tracking?.pageTrackings
      ? state.tracking.pageTrackings
          .map((trackPage: IPageTracking) => trackPage.pageTime)
          .reduce((a: number, b: number) => a + b, 0)
      : 0;

    let uniqueViewerCount: number = 0;
    if (state.tracking?.visitTrackings) {
      const recipientIds: string[] = state.tracking.visitTrackings.map(
        (trackVisit: IVisitTracking) => trackVisit.recipientId
      );
      uniqueViewerCount = new Set(recipientIds).size;
    }

    return { documentVisitCount, documentVisitTime, uniqueViewerCount };
  },
};
